import Vue from "vue";
import Router from "vue-router";
// 登录页
import Login from '@/views/Login'
// 首页
// import Home from "@/components/Home";
import Home from "../views/NewHome";
import Homepage from "@/components/homepage/homepage.vue"
// 四个产品
import IndividualTraining from "@/components/views/course/IndividualTraining/IndividualTraining.vue"// 单项训练
import PracticalTraining from "@/components/views/course/PracticalTraining/PracticalTraining.vue"// 综合实训
import RealTask from "@/components/views/course/RealTask/RealTask.vue"// 真实任务

//新智能估值 真实任务  贾新龙
import newRealTask from "@/views/newRealTask/index.vue" // 真实任务
import marketingProjectManagement from "@/views/newRealTask/marketingProjectManagement.vue"
import marketingProjectEditor from "@/views/newRealTask/components/marketingProjectEditor.vue"
import marketingProjectContent from "@/views/newRealTask/components/marketingProjectContent.vue"
// import employeeInformationTable from "@/views/newRealTask/components/employeeInformationTable"
// import personnelManagement from "@/views/newRealTask/components/personnelManagement"
import auditNewRealTask from "@/views/auditNewRealTask/index.vue" // 真实任务
import auditMarketingProjectManagement from "@/views/auditNewRealTask/marketingProjectManagement.vue"
import auditMarketingProjectEditor from "@/views/auditNewRealTask/components/marketingProjectEditor.vue"
import auditMarketingProjectContent from "@/views/auditNewRealTask/components/marketingProjectContent.vue"
import auditMarketingProjectOffice from "@/views/auditNewRealTask/components/officeArea"


import TheoryCourse from "@/components/views/course/TheoryCourse/TheoryCourse.vue"// 书证融通
// 课程管理
import CourseList from "@/components/views/course/courseListPage.vue"// 课程列表
import EditCourse from "@/components/views/course/editCourse.vue"// 编辑课程
import EditTask from "@/components/views/course/editTask.vue"// 编辑任务
// 通用首页（教师端）
import TeachClass from "@/components/views/TeachClass/index.vue"
// 通用首页（学生端）
import StudentClass from "@/components/views/TeachClass/indexStudent.vue"
// 开课管理
import CourseAdmin from "@/components/views/TeachClass/courseAdmin.vue"
// 添加测验
import AddTest from "@/components/views/course/addTestpaper.vue"
// 添加考试
import AddExam from "@/components/views/TeachClass/components/addExam.vue"
// 学员管理
import StudentAdmin from "@/components/views/TeachClass/components/studentAdmin.vue"
// 小组管理
import GroupAdmin from "@/components/views/TeachClass/components/groupAdmin.vue"
// 应用中心
import AppCenter from "@/components/views/appCenter/appCenter.vue"
// 企业微课
import Iframe from '@/components/views/iframe/iframe.vue';
// 进入课堂-课件
import Switchpage from "@/components/views/studyCenter/switch/switchpage.vue"
import Courseware from "@/components/views/studyCenter/switch/courseware/courseware.vue"
import CoursewareIndex from "@/components/views/studyCenter/switch/courseware/index.vue"
import Training2Index from "@/components/views/studyCenter/switch/courseware/training2Index.vue"
import CoursewarePreview from "@/components/views/studyCenter/switch/courseware/preview.vue"
// 进入课堂-讨论
import Discuss from "@/components/views/studyCenter/switch/discuss/discuss.vue"
import AllDiscuss from "@/components/views/studyCenter/switch/discuss/allDiscuss/allDiscuss.vue"
import TeacherDiscuss from "@/components/views/studyCenter/switch/discuss/teacherDiscuss/teacherDiscuss.vue"
import StudentDiscuss from "@/components/views/studyCenter/switch/discuss/studentDiscuss/studentDiscuss.vue"
// 进入课堂-笔记
import Note from "@/components/views/studyCenter/switch/note/note.vue"
// 进入课堂-测验
import TestPage from "@/components/views/studyCenter/switch/testing/testPage.vue"
import TestList from "@/components/views/studyCenter/switch/testing/testList.vue"
import DetailsPage from "../components/views/studyCenter/switch/testing/detailsPage.vue"
import TestPaper from "@/components/views/studyCenter/switch/testing/testPaper.vue"
import TestSimulation from "@/components/views/studyCenter/switch/testing/testSimulation.vue"
import TestSimulationNew from "@/components/views/studyCenter/switch/testing/testSimulationNew.vue"
import AloneHtml from "../views/szrt_revision/teachingDetail/list/mockexamination/alone.vue"
import AloneHtmlNew from "../views/szrt_revision/teachingDetail/list/mockexamination/aloneNew.vue"
import TestSuccess from "@/components/views/studyCenter/switch/testComponent/testSuccess.vue"
import TestSuccessNew from "@/components/views/studyCenter/switch/testSumulationComponentNew/testSuccess.vue"
import Preview from "@/components/views/studyCenter/switch/testing/preview.vue"
import StuPreview from "../components/views/studyCenter/switch/testing/stuPreview.vue"
import StuPreviewNew from "@/components/views/studyCenter/switch/testing/stuPreviewNew.vue"
// 进入课程-考试
import Examination from "@/components/views/studyCenter/switch/examination/index.vue"
import ExaminationPage from "@/components/views/studyCenter/switch/examination/examinationPage.vue"
// 进入课堂-统计
import StatisticsIndex from "@/components/views/studyCenter/switch/statistics/statisticsIndex.vue"
import StudentTheory from "@/components/views/studyCenter/switch/statistics/student/studentTheory.vue"
import StudentTraining from "@/components/views/studyCenter/switch/statistics/student/studentTraining.vue"
import ComprehensiveTrainingStudent
  from "@/components/views/studyCenter/switch/statistics/student/comprehensiveTraining.vue"
import TeacherTheory from "@/components/views/studyCenter/switch/statistics/teacher/teacherTheory.vue"
import TeacherTraining from "@/components/views/studyCenter/switch/statistics/teacher/teacherTraining.vue"
import ComprehensiveTraining from "@/components/views/studyCenter/switch/statistics/teacher/comprehensiveTraining.vue"
import ClassProgress from "@/components/views/studyCenter/switch/statistics/teacher/classProgress.vue"
import LearningDuration from "@/components/views/studyCenter/switch/statistics/teacher/learningDuration.vue"
import ClassDiscuss from "@/components/views/studyCenter/switch/statistics/teacher/classDiscuss.vue"
import PublicNotes from "@/components/views/studyCenter/switch/statistics/teacher/publicNotes.vue"
import PublicNotesList from "@/components/views/studyCenter/switch/statistics/teacher/publicNoteList.vue"
// 进入课堂-小组
import Group from "../components/views/studyCenter/switch/group/index.vue"
// 进入课堂-考勤
import WorkAttendance from '@/components/views/studyCenter/switch/workAttendance/index.vue'
// 进入课堂-通知
import Notice from '../components/views/studyCenter/switch/notice/index.vue'
// 进入课堂-设置
import TeacherSetUp from '@/components/views/studyCenter/switch/setUp/index.vue'
// 真实任务学生端
import StudentTask from '@/components/views/studyCenter/switch/realTask/index.vue'
// 进入课堂-成绩
import Achievement from '@/components/views/studyCenter/switch/achievement/index.vue'

// 教务管理
import Educational from '../components/views/educationalAdmin/educational.vue'
import EducaTeacherAdmin from '../views/szrt_revision/new_educa_module/educa/teacherManage/teacherAdmin.vue'
import EducaStudentAdmin from '../views/szrt_revision/new_educa_module/educa/studentManage/studentAdmin.vue'
import SourceSubject from '../components/views/educationalAdmin/educationalAdminMenu/sourceSubject.vue'
import CourseSharing from '../components/views/educationalAdmin/educationalAdminMenu/courseSharing.vue'
import SchoolLogo from '../views/szrt_revision/new_educa_module/educa/logoManage/schoolLogo.vue'
import CoursePlan from '../views/szrt_revision/new_educa_module/educa/classPlan/coursePlan.vue'
import SourcesubjectDetails from '../components/views/educationalAdmin/educationalAdminMenu/sourcesubjectDetails.vue'
import TestApply from '../components/views/educationalAdmin/educationalAdminMenu/testApply.vue'
import AppliedList from '../components/views/educationalAdmin/educationalAdminMenu/appliedList.vue'
import teacherPlan from '../components/views/educationalAdmin/educationalAdminMenu/teacherPlan.vue'
import ClassStatistics from "../views/szrt_revision/new_educa_module/educa/classStatistics/index.vue"
import StudentList from "../views/szrt_revision/new_educa_module/educa/classStatistics/studentList.vue"
import StatisticsPage from "../views/szrt_revision/new_educa_module/educa/classStatistics/statisticsPage.vue"
import TheoryStatistics from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/theoryStatistics.vue"
import TrainingStatistics
  from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/trainingStatistics.vue"
import ComprehensiveStatistics
  from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/comprehensiveStatistics.vue"
import ClassProgressDetails from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/classProgress.vue"
import ClassDiscussDetails from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/classDiscuss.vue"
import PublicNotesListDetails
  from "../views/szrt_revision/new_educa_module/educa/classStatistics/comp/publicNoteList.vue"
import ResourceStatisticEdu from '../views/szrt_revision/new_account_settings/accountSettings/resourceStatistic/resourceStatistic.vue'
// 个人中心
import AccountSettings from '../components/views/accountSettings/accountSettings.vue'
import PersonalInformation from '../views/szrt_revision/new_account_settings/accountSettings/personalInformation.vue'
import ChangePassword from '../views/szrt_revision/new_account_settings/accountSettings/changePassword.vue'
import SecuritySetting from '../views/szrt_revision/new_account_settings/accountSettings/securitySetting.vue'
import ResourceStatistic from '../views/szrt_revision/new_account_settings/accountSettings/resourceStatistic/resourceStatistic.vue'
// icon 库
import Zlicon from '../views/szrt_revision/new_account_settings/accountSettings/zlicon.vue'
import overallStatistics from '../views/szrt_revision/new_account_settings/accountSettings/overallStatistics/overallStatistics.vue'

//数据中心
import DataStatistics from "../components/views/dataStatistics/index.vue"

// 答案对比
import AnswerCompare from "../views/answerCompare.vue"

// 新课程学习页面
import learning_module from "../views/new_learning_module/learning_module"

// 新课程编辑页面
import zlItCourseEdit from "../views/single_resource_course/zlItCourseEdit"

// 新课程编辑页面
import new_course_editor from "../views/new_course_editor/index"

// 富文本创建界面
import creatEditor from "../views/new_course_editor/creatEditor"

// IT学习专用界面
import NewProgramming from "../views/IT/programming"
import programming from "../views/szrt_revision/Learning_details/programming"


// 新课程实训编辑页面
import course_train_set from "../views/course_train_set/index"

// 大赛练习
import competitionPractice from "../components/homepage/competitionPractice.vue"

// 新书证融通
import NewCourse from './new-course.js'

// 综合实训2.0
import NewTraining from './training2.js'

// 预览附件
import filePreview from "../views/szrt_revision/new_course_module/editCourse/sourceMaterial/filePreview";

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Login,
    },
    {
      path: "/cpkslogin",
      component: () => import('../views/TemporaryFiles/login.vue'),
    },
    {
      path: "/cpkslist",
      component: () => import('../views/TemporaryFiles/list.vue'),
    },
    {
      path: "/sjdsdx",
      component: () => import('../views/socialLogin/sjdsdx.vue'),
    },
    {
      path: "/sjdsrt",
      component: () => import('../views/socialLogin/sjdsrt.vue'),
    },
    {
      path: "/alone",
      component: () => import('../views/TemporaryFiles/alone.vue'),
    },
    {
      path: "/aloneLogin",
      component: () => import('../views/TemporaryFiles/aloneLogin.vue'),
    },
    {
      path: "/aloneA",
      component: () => import('../views/TemporaryFiles/aloneA.vue'),
    },
    {
      path: "/Home",
      name: "Home",
      component: Home
    },
    {
      path: '/filePreview',
      name: 'filePreview',
      component: filePreview
    },
    ...NewCourse,
    ...NewTraining,
    {
      path: "/homepage", // 没有用 tod-xx
      name: "homepage",
      component: Homepage,
      children: [
        {
          path: "/IndividualTraining",
          name: "IndividualTraining",
          component: IndividualTraining,
          children: [
            {
              path: "/IndividualTraining/teachClass",
              component: TeachClass
            },
            {
              path: "/IndividualTraining/studentClass",
              component: StudentClass
            },
            {
              path: "/IndividualTraining/course",
              component: CourseList
            },
            {
              path: "/IndividualTraining/appCenter",
              component: AppCenter
            },
          ]
        },
        {
          path: "/PracticalTraining",
          name: "PracticalTraining",
          component: PracticalTraining,
          children: [
            {
              path: "/PracticalTraining/teachClass",
              component: TeachClass
            },
            {
              path: "/PracticalTraining/studentClass",
              component: StudentClass
            },
            {
              path: "/PracticalTraining/course",
              component: CourseList
            },
            {
              path: "/PracticalTraining/microLecture",
              component: Iframe
            },
            {
              path: "/PracticalTraining/appCenter",
              component: AppCenter
            },
          ]
        },

        {
          path: "/RealTask",
          name: "RealTask",
          component: RealTask,
          children: [
            {
              path: "/RealTask/teachClass",
              component: TeachClass
            },
            {
              path: "/RealTask/studentClass",
              component: StudentClass
            },
            {
              path: "/RealTask/course",
              component: CourseList
            },
            {
              path: "/RealTask/microLecture",
              component: Iframe
            },
            {
              path: "/RealTask/appCenter",
              component: AppCenter
            },
          ]
        },


        {
          path: "/TheoryCourse",
          name: "TheoryCourse",
          component: TheoryCourse,
          children: [
            {
              path: "/TheoryCourse/teachClass",
              component: TeachClass
            },
            {
              path: "/TheoryCourse/studentClass",
              component: StudentClass
            },
            {
              path: "/TheoryCourse/course",
              component: CourseList
            },
          ]
        },
        {
          path: "/NewProfessionalCourses",
          name: "NewProfessionalCourses",
          component: TheoryCourse,
          children: [
            {
              path: "/NewProfessionalCourses/teachClass",
              component: TeachClass
            },
            {
              path: "/NewProfessionalCourses/studentClass",
              component: StudentClass
            },
            {
              path: "/NewProfessionalCourses/course",
              component: CourseList
            },
          ]
        },
        {
          path: "/EditCourse",
          component: EditCourse
        },
        {
          path: "/EditTask",
          component: EditTask
        },
        {
          path: "/courseAdmin",
          component: CourseAdmin
        },
        {
          path: "/addTest",
          component: AddTest
        },
        {
          path: '/AddExam',
          component: AddExam
        },
        {
          path: '/studentAdmin',
          component: StudentAdmin
        },
        {
          path: '/groupAdmin',
          component: GroupAdmin
        },
        {
          path: '/competitionPractice',
          component: competitionPractice
        }
      ]
    },

    //新智能估值 真实任务  贾新龙
    {
      path: "/newRealTask",
      name: "newRealTask",
      component: newRealTask,
      redirect: "/newRealTask/marketingProjectManagement",
      children: [
        {
          path: "/newRealTask/marketingProjectManagement",
          component: marketingProjectManagement
        },
        {
          path: "/newRealTask/components/marketingProjectEditor",
          name: "marketingProjectEditor",
          component: marketingProjectEditor,
        },

        {
          path: "/newRealTask/components/marketingProjectContent",
          name: "marketingProjectContent",
          component: marketingProjectContent,
        },
      ]
    },
    {
      path: "/auditNewRealTask",
      name: "auditNewRealTask",
      component: auditNewRealTask,
      redirect: "/auditNewRealTask/marketingProjectManagement",
      children: [
        {
          path: "/auditNewRealTask/marketingProjectManagement",
          component: auditMarketingProjectManagement
        },
        {
          path: "/auditNewRealTask/components/marketingProjectEditor",
          name: "auditMarketingProjectEditor",
          component: auditMarketingProjectEditor,
        },

        {
          path: "/auditNewRealTask/components/marketingProjectContent",
          name: "auditMarketingProjectContent",
          component: auditMarketingProjectContent,
        },
        {
          path: "/auditNewRealTask/components/officeArea",
          name: "auditMarketingProjectOffice",
          component: auditMarketingProjectOffice,
        },
      ]
    },

    { // 学习中心
      path: "/switch",
      component: Switchpage,
      children: [
        {//任务
          path: "/switch/studentTask",
          name: "任务",
          hidden: true,
          component: StudentTask,
        },
        {//课件
          path: "/switch/courseware",
          name: "课件",
          hidden: true,
          component: Courseware,
          children: [
            {
              path: "/switch/courseware/courseDetail",
              component: CoursewareIndex,
            },
            {
              path: "/switch/training2/courseDetail",
              component: Training2Index,
            },
            {
              path: "/switch/courseware/preview",
              component: CoursewarePreview
            },
          ]
        },
        {//讨论
          path: "/switch/discuss",
          name: "讨论",
          hidden: true,
          redirect: "/switch/discuss/all",
          component: Discuss,
          children: [
            { // 全部讨论
              path: "/switch/discuss/all",
              component: AllDiscuss
            },
            { // 老师答疑
              path: "/switch/discuss/teacher",
              component: TeacherDiscuss
            },
            { // 课堂交流
              path: "/switch/discuss/student",
              component: StudentDiscuss
            }
          ]
        },
        {//笔记
          path: "/switch/note",
          name: "笔记",
          hidden: true,
          component: Note
        },
        {//考勤
          path: "/switch/workattendance",
          name: "考勤",
          hidden: true,
          component: WorkAttendance,
        },
        {//小组
          path: "/switch/group",
          name: "小组",
          hidden: true,
          component: Group,
        },
        {//测验
          path: "/switch/test",
          name: "测验",
          hidden: true,
          component: TestPage,
          redirect: "/switch/test/testList",
          children: [
            { // 教师查看详情页
              path: "/switch/test/testList",
              component: TestList
            },
            { // 教师查看详情页
              path: "/switch/test/detailsPage",
              component: DetailsPage
            },
            { // 教师预览
              path: "/switch/test/preview",
              component: Preview
            },
            { // 学生预览
              path: "/switch/test/stupreview",
              component: StuPreview
            },
            { // 学生预览
              path: "/switch/test/stuPreviewNew",
              component: StuPreviewNew
            },
            { // 测验考试
              path: "/switch/test/testPaper",
              component: TestPaper
            },
            { // 模拟考试
              path: "/switch/test/testSimulation",
              component: TestSimulation
            },
            { // 模拟考试
              path: "/switch/test/testSimulationNew",
              component: TestSimulationNew
            },
            { // 交卷成功
              path: "/switch/test/success",
              component: TestSuccess
            },
            { // 交卷成功
              path: "/switch/test/successNew",
              component: TestSuccessNew
            },
          ]
        },
        {//考试
          path: "/switch/examination",
          name: "考试",
          hidden: true,
          component: ExaminationPage,
          redirect: "/switch/examination/index",
          children: [
            { //考试列表
              path: "/switch/examination/index",
              component: Examination
            },
            { // 教师查看详情页
              path: "/switch/examination/detailsPage",
              component: DetailsPage
            },
          ]
        },
        {//成绩
          path: "/switch/achievement",
          name: "成绩",
          hidden: true,
          component: Achievement,
        },
        {//统计
          path: "/switch/statistics",
          name: "统计",
          hidden: true,
          component: StatisticsIndex,
          // redirect: "/switch/test/testList",
          children: [
            { // 学生理论课统计
              path: "/switch/statistics/studentTheory",
              component: StudentTheory
              // component: StudentTraining
            },
            { // 学生单项训练统计
              path: "/switch/statistics/sudentTraining",
              component: StudentTraining
            },
            { // 学生综合实训统计
              path: "/switch/statistics/studentcComprehensive",
              component: ComprehensiveTrainingStudent
            },
            { // 学生综合实训2.0统计
              path: "/switch/statistics/studentcComprehensive2",
              component: () => import("@/components/views/studyCenter/switch/statistics2/student/comprehensiveTraining.vue"),
            },
            { // 教师理论课统计
              path: "/switch/statistics/teacherTheory",
              component: TeacherTheory
            },
            { // 教师单项训练统计
              path: "/switch/statistics/teacherTraining",
              component: TeacherTraining
            },
            { // 教师综合实训统计
              path: "/switch/statistics/comprehensiveTraining",
              component: ComprehensiveTraining
            },
            { // 教师综合实训2.0统计
              path: "/switch/statistics/comprehensiveTraining2",
              component: () => import("@/components/views/studyCenter/switch/statistics2/teacher/comprehensiveTraining.vue"),
            },
            { // 班级进度详情
              path: "/switch/statistics/classProgress",
              component: ClassProgress
            },
            { // 学习时长详情
              path: "/switch/statistics/learningDuration",
              component: LearningDuration
            },
            { // 班级讨论详情
              path: "/switch/statistics/classDiscuss",
              component: ClassDiscuss
            },
            { // 班级笔记详情
              path: "/switch/statistics/publicNotes",
              component: PublicNotes
            },
            { // 班级公开笔记列表
              path: "/switch/statistics/publicNoteList",
              component: PublicNotesList
            }
          ]
        },
        {//通知
          path: "/switch/notice",
          name: "通知",
          hidden: true,
          component: Notice,
        },
        {//设置
          path: "/switch/seachsetup",
          name: "设置",
          hidden: true,
          component: TeacherSetUp,
        },
      ]
    },
    { // 教务管理
      path: "/educa",
      component: Educational,
      name: "教务管理",
      redirect: "/educa/teacher",
      children: [
        {
          path: "/educa/teacher",
          name: "教师管理",
          component: EducaTeacherAdmin
        },
        {
          path: "/educa/student",
          name: "学生管理",
          component: EducaStudentAdmin
        },
        {
          path: "/educa/sourcesubject",
          name: "科目管理",
          component: SourceSubject
        },
        {
          path: "/educa/curriculum",
          name: "课程授权",
          component: CourseSharing
        },
        {
          path: "/educa/schoollogo",
          name: "学校logo",
          component: SchoolLogo
        },
        {
          path: "/educa/coursePlan",
          name: "开课计划",
          component: CoursePlan
        },
        {
          path: "/educa/sourcesubject/dtails",
          name: "科目详情",
          component: SourcesubjectDetails
        },
        {
          path: "/educa/testApply",
          name: "考试报名",
          component: TestApply
        },
        {
          path: "/educa/appliedList",
          name: "已报名单",
          component: AppliedList
        },
        {
          path: "/educa/teacherPlan",
          name: "教学计划填报",
          component: teacherPlan
        },
        {
          path: "/educa/classStatistics",
          name: "班课统计",
          component: ClassStatistics
        },
        {
          path: "/educa/classStatistics/studentList",
          name: "学员列表",
          component: StudentList
        },
        {
          path: "/educa/examinationManage",
          name: "校考管理",
          component: () => import('../views/szrt_revision/new_educa_module/educa/examinationManage.vue'),
        },
        {
          path: "/educa/organization",
          name: "组织管理",
          component: () => import('../views/szrt_revision/new_educa_module/educa/organization/index.vue'),
        },
        {
          path: "/educa/overallStatistics",
          name: "整体数据",
          component: overallStatistics,
        },
        {
          path: "/educa/resourceStatistic",
          name: "资源统计",
          component: ResourceStatisticEdu
        },
      ]
    },
    { // 个人中心
      path: "/settings",
      component: AccountSettings,
      name: "个人中心",
      redirect: "/settings/personalInformation",
      children: [
        {
          path: "/settings/personalInformation",
          name: "个人信息",
          component: PersonalInformation
        },
        {
          path: "/settings/changePassword",
          name: "修改密码",
          component: ChangePassword
        },
        {
          path: "/settings/securitySetting",
          name: "安全设置",
          component: SecuritySetting
        },
        {
          path: "/settings/resourceStatistic",
          name: "资源统计",
          component: ResourceStatistic
        },
        {
          path: "/settings/zlicon",
          name: "中联图标库",
          component: Zlicon
        },
        {
          path: "/settings/overallStatistics",
          name: "整体数据",
          component: overallStatistics
        }
      ]
    },
    {// 数据中心
      path: "/dataStatistics",
      component: DataStatistics,
      name: "数据中心",
      children: []
    },
    {
      path: "/statisticsPage",
      component: StatisticsPage,
      name: "教务中心-班课统计",
      children: [
        {
          path: "/statisticsPage/theory",
          name: "书证融通统计",
          component: TheoryStatistics
        },
        {
          path: "/statisticsPage/training",
          name: "单项训练统计",
          component: TrainingStatistics
        },
        {
          path: "/statisticsPage/comprehensive",
          name: "综合实训统计",
          component: ComprehensiveStatistics
        },
        {
          path: "/statisticsPage/classProgress",
          name: "查看班级进度",
          component: ClassProgressDetails
        },
        {
          path: "/statisticsPage/classDiscuss",
          name: "查看班级讨论",
          component: ClassDiscussDetails
        },
        {
          path: "/statisticsPage/publicNoteList",
          name: "查看公开笔记",
          component: PublicNotesListDetails
        }
      ]
    },
    {// 答案对比
      path: "/answerCompare",
      component: AnswerCompare,
      name: "答案对比",
      children: []
    },
    { // 新课程页面
      path: "/zlItCourseEdit",
      name: "zlItCourseEdit",
      component: zlItCourseEdit,
    },
    { // 新课程页面
      path: "/new_course_editor",
      name: "new_course_editor",
      component: new_course_editor,
    },
    { // 富文本创建页面
      path: "/creatEditor",
      name: "creatEditor",
      component: creatEditor,
    },
    { // 新课程页面
      path: "/course_train_set",
      name: "course_train_set",
      component: course_train_set,
    },
    { // 新课程学习页面
      path: "/learning_module",
      name: "learning_module",
      component: learning_module,
    },
    {  // 课程模块 2022.5.12 （课程模块2.0）
      path: "/course",
      name: "course",
      component: () => import("@/views/course"),
      redirect: '/course/courseContent',
      children: [
        {  //  课程基础信息
          path: "/course/courseBasicInfo",
          name: "courseBasicInfo",
          component: () => import("@/views/course/courseBasicInfo.vue"),
        },
        {  //  课程内容
          path: "/course/courseContent",
          name: "courseContent",
          component: () => import("@/views/course/courseContent.vue"),
        },
        {  //  课程素材
          path: "/course/courseSource",
          name: "courseSource",
          component: () => import("@/views/course/courseSource.vue"),
        },
        {  //  回收站
          path: "/course/courseContentRecycle",
          name: "courseContentRecycle",
          component: () => import("@/views/course/courseContentRecycle.vue"),
        },
        // {  //  课前预习
        //   path: "/course/coursePreview",
        //   name: "coursePreview",
        //   component: () => import("@/views/course/coursePreview.vue"),
        // },
        // {  //  课后复习
        //   path: "/course/courseReview",
        //   name: "courseReview",
        //   component: () => import("@/views/course/courseReview.vue"),
        // },
      ]
    },
    {   // IT 学习专用界面
      path: "/programming",
      name: "programming",
      component: programming,
    },
    {   // 新的IT
      path: "/NewProgramming",
      name: "NewProgramming",
      component: NewProgramming,
    },
    {
      path: '/notice',
      name: "notice",
      component: () => import("@/components/noticeList.vue")
    },
    {
      path: '/previewNotice',
      name: "previewNotice",
      component: () => import("@/components/previewNotice.vue")
    },
    {
      path: '/no-permission',
      name: "noPermission",
      component: () => import("@/components/noPermission.vue")
    },
    { // 考试单独页
      path: "/alone-html",
      name: "aloneHtml",
      component: AloneHtml
    },
    { // 考试单独页
      path: "/alone-html-new",
      name: "aloneHtmlNew",
      component: AloneHtmlNew
    },
    {
      path: "*",
      name: "all-404",
      component: () => import("@/views/404.vue")
    }
  ]
});

let routerList = ['/notice', '/previewNotice', '/cpkslogin', '/sjdsdx', '/sjdsrt', '/coursePreviewTest', '/alone', '/aloneLogin', '/aloneA'];  // 不需要身份认证的页面

router.beforeEach((to, from, next) => {
  //  新开页保留登录信息 避免无权限等问题
  // if (localStorage.sessionStorageConfiguration) {
  //   let a = JSON.parse(localStorage.sessionStorageConfiguration)
  //   for (const key in a) {
  //     if (Object.hasOwnProperty.call(a, key)) {
  //       sessionStorage.setItem(key, a[key])
  //     }
  //   }
  // }
  let token = localStorage.getItem('Authorization');
  let passwordEdit = sessionStorage.getItem('passwordEdit');
  if (passwordEdit) { // 如果是重置密码阶段，要返回到登录界面
    sessionStorage.removeItem('passwordEdit');
    localStorage.removeItem('Authorization')
    next('/'); // 去登录页
  } else if (token && token !== 'null') {
    // console.log('--token--', to, token,  passwordEdit)
    // if (to.path === "/"){
    //   next('/Home')
    // }else{
    next();
    // }
  } else {
    if (routerList.includes(to.path) || to.path === "/") {
      sessionStorage.clear();
      localStorage.clear();
      next();
    } else {
      next('/'); // 去登录页
    }
  }

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js